"use client";
import { BlogPageContext } from "@/helpers/contexts/BlogPageContext";
import { SectionPromo } from "@/components/shared/sections/SectionPromo";
import { BlogTopWriters } from "@/components/pages/blog/BlogTopWriters";
import { BlogMain } from "@/components/pages/blog/search/BlogMain";
import { BlogPageProps } from "@/types/strapi/blogPage";
import useBlogSearch from "@/helpers/blog/useBlogSearch";
import { useClientPagination } from "@/helpers/blog/useClientPagination";
import { BlogSearch } from "@/components/pages/blog/search/BlogSearch";
import { TaxonomiesList } from "@/components/pages/blog/search/TaxonomiesList";
import { PageGradientWrapper } from "@/components/layout/PageGradientWrapper";
import s from "./BlogPage.module.scss";

export const BlogPage = (props: BlogPageProps) => {
  const pagination = useClientPagination();

  const { search, handleSearch } = useBlogSearch();

  return (
    <BlogPageContext.Provider
      value={{
        ...props,
        clientPagination: pagination,
      }}
    >
      <PageGradientWrapper>
        <SectionPromo
          background="transparent"
          promoWide
          breadcrumbs={[
            { position: 1, name: "Main", item: "/" },
            { position: 2, name: "Blog", item: "/blog" },
          ]}
          heading={props.blog.heading}
          subheading={props.blog.description}
        >
          <BlogSearch
            search={search}
            count={props.pagination.total}
            handleSearch={handleSearch}
            isNotFound={props.notFound}
            className={s.blogSearch}
          />
          {props.categories && !!props.categories.length && (
            <TaxonomiesList list={props.categories} heading="Browse by categories" />
          )}
          <BlogTopWriters />
        </SectionPromo>

        <BlogMain />
      </PageGradientWrapper>
    </BlogPageContext.Provider>
  );
};
